(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  class CardSelector {
    constructor(selector) {
      this.el = document.querySelector(selector);
      this.el.classList = "";
      this.imageEls = this.el.querySelectorAll(`[data-sk-card-image-icon]`);
      this.dataEl = this.el.querySelector(`#requested-card`);
      this.outerEl = this.el.querySelector(`[data-sk-outer]`);
      this.innerEl = this.el.querySelector(`[data-sk-inner]`);
      this.ccEls = this.el.querySelectorAll("[data-sk-cc]");
      this.messageEl = this.el.querySelector(`#card-message`);
      this.questionElYes = this.el.querySelector("#yes")
      this.questionElNo = this.el.querySelector("#no")
      this.cardWidgetEl = this.el.querySelector("[data-sk-card-widget]")
      this.data = {};
      this._bind();
    }

    _bind() {
      console.log("here")
      this._bindCardSelection()
      this._bindNote()
      this._bindQuestion()
    }
    
    _bindCardSelection() {
      let cs = this
      for (let i = 0; i < this.imageEls.length; i++) {
        this.imageEls[i].addEventListener("click", function(event) {
          const el = event.currentTarget;
          const img = el.querySelector(`img`)

          // Select the correct image
          cs.el.querySelectorAll(`.selected`).forEach(e => e.classList.remove("selected"))
          img.classList.add('selected');

          // change the data
          cs.data.template = el.getAttribute("data-sk-card-template")
          cs._updateData()

          //modify the outer
          cs.ccEls.forEach(e => e.classList.add("hidden"))
          cs.el.querySelectorAll(`[data-sk-cc=${cs.data.template}]`).forEach(e => e.classList.remove("hidden"));

          // Add selected Class
          img.classList.add('selected');
        });
      }
    }
    
    _bindNote() {
      let cs = this
      this.messageEl.addEventListener("input", function(event) {
        cs.data.message = event.currentTarget.value;
        cs._updateData()
      });
    }
    _cardState(checked) {
        if (checked) {
          this.cardWidgetEl.classList.remove("hidden")
          this._updateData()
        } else {
          this.cardWidgetEl.classList.add("hidden")
          this.dataEl.value = null
        }
    }
    _bindQuestion() {
      let cs = this
      this.questionElYes.addEventListener("change", function(event) {
        cs._cardState(this.checked)
        if (!cs.data.template){
          console.log("click")
          cs.imageEls[0].click()
        }
      });
      this.questionElNo.addEventListener("change", function(event) {
        cs._cardState(!this.checked)
      });
    }

    _updateData() {
      this.dataEl.value = JSON.stringify(this.data)
    }
  }

  if (document.querySelector('[data-gift-card="false"]')) {
    new CardSelector("#card-selector")
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  

  class QKVariantToggle {
    constructor(layer) {
      this.layer = layer;
      this.$els = document.querySelectorAll(`[data-qk-toggle="variant-toggle"][data-qk-layer="${this.layer}"]`);
      this._bind();
    }

    _bind() {
      let self = this;
      document.querySelectorAll("body")[0].addEventListener("update.variant", function(event) {
        self.update(event.detail.variant?.id);
      }); 
    }

    update(variantId) {
      let els = Array.from(this.$els)

      els.forEach(e=> {
        e.classList.add("hidden");
      })
      let defaultEl = els.filter(e=> {
        return e.dataset.qkVariant == "default"
      })
      let foundEl = els.filter(e=> {
        return e.dataset.qkVariant == variantId
      })
      if (foundEl.length) {
        let el = foundEl[0];
        if (el.innerHTML.trim() !== "") {
          foundEl[0].classList.remove("hidden");
        } else {
          defaultEl[0].classList.remove("hidden");
        }
      } else {
        defaultEl[0].classList.remove("hidden");
      }
    }
  }
  
  // Loop through each element and create a new instance of QKVariantToggle
  document.querySelectorAll('[data-qk-toggle="variant-toggle"][data-qk-variant="default"][data-qk-layer]').forEach(function(element) {
    const layer = element.getAttribute("data-qk-layer");
    new QKVariantToggle(layer);
  });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Build request URL
  var requestUrl = productRecommendationsSection.dataset.url;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;

     let r = new theme.peekCarouselSplide(productRecommendationsSection);
    console.log(r)
      
      // theme.peekCarousel.init(
      //   productRecommendationsSection,
      //   $('.js-related-product-carousel', productRecommendationsSection),
      //   '.productRecommendations',
      //   function() {
      //     return $(window).width() < 768
      //   },
      //   false
      // );
      // theme.initUniformHeightMonitor(productRecommendationsSection, '.product-block__image-container', '.product-block__image-container .image-one');
    }
  };
  request.send();
};
// Reload the section in the editor when a setting changes
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
document.addEventListener("shopify:section:unload", function(event) {
  // if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
  //   theme.destroyUniformHeightMonitor($('.product-recommendations', event.target));
  //   theme.peekCarousel.destroy(
  //     $('.product-recommendations', event.target),
  //     $('.js-related-product-carousel', event.target),
  //     '.productRecommendations'
  //   );
  // }
});
// Fetching the recommendations on page load
document.addEventListener("DOMContentLoaded", function(event) {
  loadProductRecommendationsIntoSection();
});

  } catch(e) { console.error(e); }
})();
})();
